import { render, staticRenderFns } from "./BillingTrackerAnnouncementBoard.vue?vue&type=template&id=106c97e8&scoped=true&"
import script from "./BillingTrackerAnnouncementBoard.vue?vue&type=script&lang=js&"
export * from "./BillingTrackerAnnouncementBoard.vue?vue&type=script&lang=js&"
import style0 from "./BillingTrackerAnnouncementBoard.scss?vue&type=style&index=0&id=106c97e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.9.6_@vue+compiler-sfc@3.5.11_babel-core@7.0.0-bridge.0_@babel+core@7.17.9_f17ab4d8c27c5d7082708fbbc2f82c9d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c97e8",
  null
  
)

export default component.exports